<template>
	<div class="wages wrapper shadow">
		<div class="operation">
			<div class="left">
				<div class="main-title">工资统计表</div>
			</div>
			<div class="right">
        <el-date-picker class="department" v-model="query.startDate" type="month" placeholder="开始月份" format="YYYY-MM"
                        value-format="YYYY-MM" />
        <el-date-picker class="department" v-model="query.endDate" type="month" placeholder="结束月份" format="YYYY-MM"
                        value-format="YYYY-MM" />
        <el-select v-model="query.type" placeholder="查询类型">
          <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-input v-model="query.keyword" placeholder="请输入查询内容" />
				<el-button type="primary" @click="getList">查询</el-button>
				<el-button type="primary" @click="exportSubmitForm">导出</el-button>
			</div>
		</div>
		<!-- 表格 -->
    <p>{{footerText}}</p>
		<el-table class="table" header-row-class-name="main-table-header" :data="tableData" border height="670"
			:span-method="objectSpanMethod">
			<el-table-column label="" min-width="150" prop="name" align="center">
			</el-table-column>
			<el-table-column label="" prop="type" align="center"> </el-table-column>
			<el-table-column v-for="(month, idx) in months" :key="idx"
                       :prop="'m'+idx"
                       :label="month" min-width="110" align="center">
        <template #default="scope">
          <div>{{scope.row['m'+idx].toString().split('|')[0]}}</div>
          <el-tag size="mini"
                  v-if="scope.row['m'+idx].toString().split('|').length > 0 &&
                  scope.row['m'+idx].toString().split('|')[1]"
          >
            {{scope.row['m'+idx].toString().split('|')[1]}}
          </el-tag>
        </template>
      </el-table-column>
		</el-table>
	</div>
</template>
<script setup>
	import {
		ref
	} from "@vue/reactivity";
	import {
		fetchLastMonth
	} from "@/api/payroll";
  import {
    fetchAnnual, fetchStatisticData
  } from "@/api/report";
	import {
		onMounted
	} from "vue";

	onMounted(() => {
	});

	const getList = () => {
		if (!query.value.keyword) {
			ElMessage({
				type: "error",
				message: "请输入查询内容！",
			});
			return;
		}
    fetchStatisticData(query.value).then((res) => {
			let data = res.data;
      handleFooter(data);
			handleData(data);
		});
	};

  const months = ref([])

  const getMonthList = (data) => {
    let monthList = [];
    data
        .map((e) => e.month)
        .forEach((d) => {
          if (monthList.indexOf(d) === -1) {
            monthList.push(d);
          }
        });
    return monthList
  }

	const handleData = (data) => {
		let nameList = [];
    let monthList = getMonthList(data);
		let list = [];
		data
			.map((e) => e.name)
			.forEach((d) => {
				if (nameList.indexOf(d) === -1) {
          nameList.push(d);
				}
			});
    months.value = monthList
    nameList.forEach((e) => {
      if (query.value.type == 2) {
        let item0 = {};
        item0.name = e;
        monthList.forEach((m, idx) => {
          item0["type"] = "部门";
          let mItem = data
              .filter((d) => d.name === e && d.month === m)
          let departmentName = mItem.length > 0 ? mItem[0].departmentName : ''
          item0["m" + idx] = departmentName;
        })
        list.push(item0);
      }
			let item1 = {};
			item1.name = e;
      monthList.forEach((m, idx) => {
        item1["type"] = "基本";
        let mItem = data
            .filter((d) => d.name === e && d.month === m)
        let val =  data
            .filter((d) => d.name === e && d.month === m)
            .map((d) => d.baseSalary)
            .reduce((a, b) => a + b, 0).toFixed(2)
        item1["m" + idx] = val;
        if(item1["m" + idx]=='0.00'){
          item1["m" + idx]=0
        }
      })
			list.push(item1);
			let item2 = {};
			item2.name = e;
      monthList.forEach((m, idx) => {
        item2["type"] = "工龄";
        item2["m" + idx] = data
            .filter((d) => d.name === e && d.month === m)
            .map((d) => d.annualLeaveAllowance)
            .reduce((a, b) => a + b, 0).toFixed(2);
        if(item2["m" + idx]=='0.00'){
          item2["m" + idx]=0
        }
      })
			list.push(item2);
			let item3 = {};
			item3.name = e;
      monthList.forEach((m, idx) => {
        item3["type"] = "绩效";
        item3["m" + idx] = data
            .filter((d) => d.name === e && d.month === m)
            .map((d) => d.performanceSalary)
            .reduce((a, b) => a + b, 0).toFixed(2);
        if(item3["m" + idx]=='0.00'){
          item3["m" + idx]=0
        }
      })
			list.push(item3);
      // 其他
      let item4 = {};
      item4.name = e;
      monthList.forEach((m, idx) => {
        item4["type"] = "其他";
        item4["m" + idx] = data
            .filter((d) => d.name === e && d.month === m)
            .map((d) => d.otherSalary)
            .reduce((a, b) => a + b, 0).toFixed(2);
        if(item4["m" + idx]=='0.00'){
          item4["m" + idx]=0
        }
      })
      list.push(item4);
		});
		let count1 = {};
		count1.name = "总计";
    monthList.forEach((m, idx) => {
      count1["type"] = "基本";
      count1["m" + idx] = data
          .filter((d) => d.month === m)
          .map((d) => d.baseSalary)
          .reduce((a, b) => a + b, 0).toFixed(2);
      if(count1["m" + idx]=='0.00'){
        count1["m" + idx]=0
      }
    })
		list.push(count1);
		let count2 = {};
		count2.name = "总计";
    monthList.forEach((m, idx) => {
      count2["type"] = "工龄";
      count2["m" + idx] = data
          .filter((d) => d.month === m)
          .map((d) => d.annualLeaveAllowance)
          .reduce((a, b) => a + b, 0).toFixed(2);
      if(count2["m" + idx]=='0.00'){
        count2["m" + idx]=0
      }
    })
		list.push(count2);
		let count3 = {};
		count3.name = "总计";
    monthList.forEach((m, idx) => {
      count3["type"] = "绩效";
      count3["m" + idx] = data
          .filter((d) => d.month === m)
          .map((d) => d.performanceSalary)
          .reduce((a, b) => a + b, 0).toFixed(2);
      if(count3["m" + idx]=='0.00'){
        count3["m" + idx]=0
      }
    })
		list.push(count3);
    let count4 = {};
    count4.name = "总计";
    monthList.forEach((m, idx) => {
      count4["type"] = "其他";
      count4["m" + idx] = data
          .filter((d) => d.month === m)
          .map((d) => d.otherSalary)
          .reduce((a, b) => a + b, 0).toFixed(2);
      if(count4["m" + idx]=='0.00'){
        count4["m" + idx]=0
      }
    })
    list.push(count4);
		tableData.value = list;
	};

  const footerText = ref('');

  const handleFooter = (data) => {
    let footer = ''
    let monthList = getMonthList(data);

    const baseSalarySum = data
        .map((d) => d.baseSalary)
        .reduce((a, b) => a + b, 0).toFixed(2);
    const annualLeaveAllowanceSum = data
        .map((d) => d.annualLeaveAllowance)
        .reduce((a, b) => a + b, 0).toFixed(2);
    const performanceSalarySum = data
        .map((d) => d.performanceSalary)
        .reduce((a, b) => a + b, 0).toFixed(2);
    const actualSalarySum = data
        .map((d) => d.actualSalary)
        .reduce((a, b) => a + b, 0).toFixed(2);
    const otherSalarySum = data
        .map((d) => d.otherSalary)
        .reduce((a, b) => a + b, 0).toFixed(2);
    const baseSalaryAvg = (baseSalarySum / monthList.length).toFixed(2);
    const annualLeaveAllowanceAvg = (annualLeaveAllowanceSum / monthList.length).toFixed(2);
    const performanceSalaryAvg = (performanceSalarySum / monthList.length).toFixed(2);
    const actualSalaryAvg = (actualSalarySum / monthList.length).toFixed(2);
    const otherSalaryAvg = (otherSalarySum / monthList.length).toFixed(2);
    const payableSalarySum = data
        .map((d) => d.payableSalary)
        .reduce((a, b) => a + b, 0).toFixed(2);
    const socialSecuritySum = data
        .map((d) => d.socialSecurity)
        .reduce((a, b) => a + b, 0).toFixed(2);
    const otherDeductionsSum = data
        .map((d) => d.otherDeductions)
        .reduce((a, b) => a + b, 0).toFixed(2);
    const payableSalaryAvg = (payableSalarySum / monthList.length).toFixed(2);
    const socialSecurityAvg = (socialSecuritySum / monthList.length).toFixed(2);
    const otherDeductionsAvg = (otherDeductionsSum / monthList.length).toFixed(2);
    footer = `基本工资月平均：${baseSalaryAvg}；工龄工资月平均：${annualLeaveAllowanceAvg}；
          绩效月平均：${performanceSalaryAvg}；其他工资月平均：${otherSalaryAvg}；实发工资月平均：${actualSalaryAvg}；应发工资月平均：${payableSalaryAvg}；
          社保扣款月平均：${socialSecurityAvg}；其他扣款月平均：${otherDeductionsAvg}`

    footerText.value = footer
  }

	//月份
	const query = ref({
		type: 1,
    keyword: "",
    startDate: dayjs().add(-1, 'month').format("YYYY-MM"),
    endDate: dayjs().format("YYYY-MM"),
	});
	import FileSaver from "file-saver";
	import XLSX from "xlsx";
	import {
		ElMessage
	} from "element-plus";
  import dayjs from "dayjs";

	const exportSubmitForm = async () => {
		if (tableData.value.length === 0) {
			ElMessage({
				type: "error",
				message: "请先查询数据！",
			});
			return;
		}
		var wb = XLSX.utils.table_to_book(document.querySelector(".table"));
		var wbout = XLSX.write(wb, {
			bookType: "xlsx",
			bookSST: true,
			type: "array",
		});
		try {
			FileSaver.saveAs(
				new Blob([wbout], {
					type: "application/octet-stream"
				}),
				"工资统计表.xlsx"
			);
		} catch (e) {
			if (typeof console !== "undefined") console.log(e, wbout);
		}
		return wbout;
	};
	// 表格
	const tableData = ref([]);

	const objectSpanMethod = ({
		rowIndex,
		columnIndex
	}) => {
    let span = 3
    if (query.value.type == 2) {
      span = 5
    }
		if (columnIndex === 0) {
			if (rowIndex % span === 0) {
				return {
					rowspan: span,
					colspan: 1,
				};
			} else {
				return {
					rowspan: 0,
					colspan: 0,
				};
			}
		}
	};

  const typeList = ref([
    {
      value: 1,
      label: '岗位级别'
    },
    {
      value: 2,
      label: '姓名'
    }
  ])


</script>
<style lang="scss" scoped>
	.tips {
		line-height: 26px;
	}
</style>
